import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import Image from "components/image";
import PageGallery from "components/pagegallery";
import collectionMeta from "content/collections/argentine-boas.json";
import { animalGridFromJson } from "hooks/useGallery";
import husbandryImg from "img/argentineboas/Argentine Boa Constrictors.png";

const animalGridData = animalGridFromJson(collectionMeta);

const ArgentineBoas = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Argentine Boas (Boa constrictor occidentalis)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/argentine-boas" />
      </Helmet>
      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />
      <AnimalGrid data={animalGridData} />
      <BodyText>
        <p>
          I have a pair of Argentine boas - a male born in 2022, and a female born in 2024. I don't 
          yet have much experience with them, but I am preparing for both of them to get large. At 
          the moment they are in 5' cages, but they will soon each have an 8' cage to live in as adults.
        </p>
        <p>
          What excites me the most about this species is the dark, cryptic markings they have, especially
          on their heads. 
        </p>
      </BodyText>

      <h1>Husbandry</h1>
      <Image src={husbandryImg} />
      <p>
        See{" "}
        <Link to="/husbandry-charts">how to read the husbandry charts</Link>.
      </p>

      <BodyText>
        <p>
          Like I said, I don't have a lot of experience yet with this species, but this chart represents
          what I am doing currently with them in terms of temperatures, lighting, and feeding. I do expect
          that this will be modified over the years so check back and see what updates I have made.
        </p>
      </BodyText>

      <PageGallery slug="argentine-boas" maxWidth="900" />
    </ContentBox>
  );
};

export default ArgentineBoas;
